import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { findRecord } from '@warp-drive/utilities/json-api';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';
import type { Store as StoreService } from '@warp-drive/core';
import type { PersonExtension as PersonModel } from 'tio-data/data/resources/person.ext';

export default class AuthenticatedCareerPathwaysFinanceHistoryRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;
  @service declare store: StoreService;

  async model() {
    const personId = this.sessionContext.user.person.id!;

    const [contributionHistory, employerContributions, dataSourceInfo, personResult] =
      await Promise.all([
        this.reimaginedData.fetchContributionHistory(),
        this.reimaginedData.fetchEmployerContributions(),
        this.reimaginedData.getDataSourceInfo(),
        this.store.request(
          findRecord<PersonModel>('person', personId, {
            include: 'accounts.financial-institution,accounts.loans',
            reload: true,
          })
        ) as Promise<{ content: { data: PersonModel } }>,
      ]);

    const person = personResult.content.data;

    return {
      contributionHistory,
      employerContributions,
      dataSourceInfo,
      person,
    };
  }
}
